__turbopack_context__.v({
  "btnLabel": "phytQW_btnLabel",
  "buttonFocused": "phytQW_buttonFocused",
  "closeBtn": "phytQW_closeBtn",
  "closeBtnWrapper": "phytQW_closeBtnWrapper",
  "drawerWrapper": "phytQW_drawerWrapper",
  "myDrawerStyle": "phytQW_myDrawerStyle",
  "openBtn": "phytQW_openBtn",
});
